import { TOfferDataRequirement } from '../../../../types';
import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';

type TProps = {
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const AgedDebtorReport = ({ isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title="Aged debtor report"
      documentType="aged debtor report"
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        This should be a list of invoices you have issued but are yet to be
        paid, and ideally grouped by the number of days outstanding e.g. (30,
        60, 90+ days).{' '}
        <a
          href="https://gocardless.com/guides/posts/aged-debtors-report/"
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </p>
    </DocumentRequirement>
  );
};

export default AgedDebtorReport;
